import React, { createContext, useState, useEffect, useRef } from 'react';
import { isTokenValid } from '../utils/tokenUtils';
import { useDispatch, useSelector } from 'react-redux';
import { logoutRequest } from '../redux/actions/authActions';

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const refresh = useSelector((state) => state.auth.refreshToken);
  const access = useSelector((state) => state.auth.accessToken);
  const session_timeout = localStorage.getItem("session_minutes");
  const dispatch = useDispatch();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const timeoutId = useRef(null);
  const [showWarning, setShowWarning] = useState(false);
  useEffect(() => {
    // Check for token in localStorage
    const token = localStorage.getItem('accessToken');

    // Validate the token
    if (token && isTokenValid(token)) {
      setIsAuthenticated(true);
      console.log("Token is valid, user is authenticated.");
    } else {
      console.log("No valid token found, user is not authenticated.");
    }
  }, []);

  const login = (token) => {
    // Set token in localStorage if you want to persist it across refreshes
    localStorage.setItem('accessToken', token);
    setIsAuthenticated(true); // Update the authentication state
  };

  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('accessToken'); // Clear token on logout
  };

  useEffect(() => {
    if (!access || !refresh) {
      return;
    }

    const inactivityMinutes = session_timeout;
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];

    const handleActivity = () => {
      if (showWarning) {
        setShowWarning(false);
      }
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }

      timeoutId.current = setTimeout(() => {
        // console.log('User has been inactive since:', new Date().toLocaleTimeString());
        // console.log("User inactive → force logout");
        setShowWarning(true);
      }, inactivityMinutes * 60 * 1000);
    };

    // Add event listeners
    events.forEach(event => {
      document.addEventListener(event, handleActivity);
    });

    // Initialize timer
    handleActivity();

    // Cleanup
    return () => {
      events.forEach(event => {
        document.removeEventListener(event, handleActivity);
      });
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
        timeoutId.current = null;
      }
    };
  }, [isAuthenticated, dispatch, refresh, access]);


  const handleContinue = () => {
    setShowWarning(false);
    document.dispatchEvent(new MouseEvent('mousedown'));
  };

  const handleLogout = () => {
    setShowWarning(false);
    dispatch(logoutRequest({ refresh, access }));
  };
  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
      {/* <InactivityWarning open={showWarning} onContinue={handleContinue} onLogout={handleLogout} warningSeconds={15} /> */}
    </AuthContext.Provider>
  );
};

export default AuthProvider;

